import { useCallback, useMemo } from 'react';
import { IVehicleTile } from '../../../../../types/vehicleTile';
import { removeViewedVehicleItemLocalStorage } from '../../../../home/utilities/viewedVehiclesTileBuilder';
import { useUftVehicleDisplay } from '../../../utilities/uftVehicleDisplay';
import useAppState from '../../../../../common/state/appState';
import UftCarTilesCarousel from '../../../../../components/carousels/car-tiles/CarTilesCarousel/UftCarTilesCarousel';

const UftYouLookedAt = () => {
    const isLoading = useAppState((state) => state.isLoading);
    const recentlyViewedVehicles = useAppState((state) => state.recentlyViewedVehicles);
    const removeRecentlyViewedVehicle = useAppState((state) => state.removeRecentlyViewedVehicle);
    const recentlyViewedStockNumbers = useMemo(
        () => new Set(recentlyViewedVehicles.map((vehicle) => vehicle.stockNumber)),
        [recentlyViewedVehicles],
    );
    const { displayedViewedVehicles, shouldTopUpFromRecommendations } = useUftVehicleDisplay();

    const onRemove = useCallback(
        (vehicle: IVehicleTile) => {
            if (!recentlyViewedStockNumbers.has(vehicle.stockNumber)) {
                return;
            }

            removeRecentlyViewedVehicle(vehicle.stockNumber);
            removeViewedVehicleItemLocalStorage(vehicle);
        },
        [recentlyViewedStockNumbers, removeRecentlyViewedVehicle],
    );

    if (isLoading || displayedViewedVehicles.length === 0) {
        return <></>;
    }

    const title = shouldTopUpFromRecommendations ? 'Keep exploring' : 'You looked at';

    return (
        <UftCarTilesCarousel
            title={title}
            carouselId="viewed-vehicles"
            vehiclesData={displayedViewedVehicles}
            onRemove={onRemove}
            isRemoveEnabled
            sectionName="You looked at"
            nextFocus="finance-promos"
        />
    );
};

export default UftYouLookedAt;
